// Configuração da API
// Em produção, usa o domínio dedicado da API
// Em desenvolvimento, usa porta 3001 diretamente
const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// Detectar se está em produção VIP Tecnologia
const isVipProduction = window.location.hostname === 'santarita.viptecnologia.com.br';

// URL da API
export const API_URL = process.env.REACT_APP_API_URL ||
  (isDevelopment ? `http://${window.location.hostname}:3566/api` :
   isVipProduction ? 'https://apisantarita.viptecnologia.com.br/api' :
   '/api');

// URL do Socket.IO (base, sem /api)
export const SOCKET_URL = isDevelopment
  ? `http://${window.location.hostname}:3566`
  : isVipProduction
    ? 'https://apisantarita.viptecnologia.com.br'
    : window.location.origin;
